module.exports = __webpack_public_path__ + "static/media/a.a22ab2af.jpg";